module.exports = __webpack_public_path__ + "static/img/new.5de285c0.svg";